import styled from "styled-components";
import FormLabel from "../FormLabel";

const HintText = styled(FormLabel)`
  color: ${(p) => p.theme.colors.neutral6};
  margin-top: 6px;
  margin-bottom: 8px;
  font-weight: 400;
  font-size: 13px;
  position: relative;
  left: 2px;
`;

export default HintText;
